import type { CSSProperties, FC, PropsWithChildren } from 'react';
import styles from './modal.module.css';

interface ModalBodyProps {
  style?: CSSProperties;
}

export const ModalBody: FC<PropsWithChildren & ModalBodyProps> = ({ children, style = {} }) => {
  return (
    <div id={'modal-body'} style={style} className={styles.body}>
      {children}
    </div>
  );
};
